module.exports = __webpack_public_path__ + "img/charterscanners.003be4cf.png";